import React from 'react';
import './App.css';
import TopPageContainer from './containers/TopPageContainer';

const App: React.FC = () => {
  return (
    <React.Fragment>
      <TopPageContainer />
    </React.Fragment>
  );
}

export default App;